import { PURGE } from "redux-persist";

var initialState = {
  isUserLogin: false,
  availabilityMessage: "",
  loginMessage: "",
  webBanner: true,
  loginResponse: null,
  userEmail: "",
  userPassword: "",
  userPhone: "",
  activateAccountModal: false,
  activateAccountOtpModal: false,
  activateAccountEmail: "",
  updatePasswordModal: false,
  updatePasswordEmail: "",
  updatePasswordUsername: "",
  updatePasswordPin: "",
  updatePasswordNewPassword: "",
  updatePasswordResponse: null,
};

const Login = (state = initialState, { type, payload }) => {
  switch (type) {
    case PURGE:
      return initialState;

    case "RESET_STORE":
      return (state = initialState);

    case "SET_USER_LOGIN":
      return {
        ...state,
        isUserLogin: payload,
      };
    case "SET_WEB_BANNER":
      return {
        ...state,
        webBanner: payload,
      };

    case "SET_LOGIN_RESPONSE":
      return {
        ...state,
        loginResponse: payload,
      };

    case "SET_USER_EMAIL":
      return {
        ...state,
        userEmail: payload,
      };
    case "SET_USER_PASSWORD":
      return {
        ...state,
        userPassword: payload,
      };
    case "SET_LOGIN_MESSAGE":
      return {
        ...state,
        loginMessage: payload,
      };
    case "SET_AVAILABILITY_MESSAGE":
      return {
        ...state,
        availabilityMessage: payload,
      };
    case "SET_USER_PHONE":
      return {
        ...state,
        userPhone: payload,
      };
    case "SET_ACTIVATE_ACCOUNT_MODAL":
      return {
        ...state,
        activateAccountModal: payload,
      };
    case "SET_ACTIVATE_ACCOUNT_OTP_MODAL":
      return {
        ...state,
        activateAccountOtpModal: payload,
      };
    case "SET_ACTIVATE_ACCOUNT_EMAIL":
      return {
        ...state,
        activateAccountEmail: payload,
      };
    case "SET_UPDATE_PASSWORD_MODAL":
      return {
        ...state,
        updatePasswordModal: payload,
      };
    case "SET_UPDATE_PASSWORD_EMAIL":
      return {
        ...state,
        updatePasswordEmail: payload,
      };
    case "SET_UPDATE_PASSWORD_USERNAME":
      return {
        ...state,
        updatePasswordUsername: payload,
      };
    case "SET_UPDATE_PASSWORD_PIN":
      return {
        ...state,
        updatePasswordPin: payload,
      };
    case "SET_UPDATE_PASSWORD_NEW_PASSWORD":
      return {
        ...state,
        updatePasswordNewPassword: payload,
      };
    case "SET_UPDATE_PASSWORD_RESPONSE":
      return {
        ...state,
        updatePasswordResponse: payload,
      };

    default:
      return state;
  }
};

export default Login;
